import React from 'react';
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import moment from 'moment'
import { useController, useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import cn from "classnames";
import { dateFormat } from "../../lib/settings";

const DatePickerInput = ({ name, handleChange }) => {
  const { control } = useFormContext()
  const {
    field: { value, onChange },
    fieldState: { invalid },
    formState: { errors }
  } = useController({ name, control })

  const disabledDate = current => {
    return current && current < moment().subtract(1, 'd');
  }

  const onChangeExtend = (date, dateString) => {
    onChange(dateString)
    handleChange(name, dateString)
  }

  return (
    <>
      <DatePicker
        format={dateFormat}
        allowClear={false}
        value={moment(value, dateFormat)}
        className={cn('form-control', {'is-invalid': invalid })}
        disabledDate={disabledDate}
        onChange={onChangeExtend}
      />
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => (
          <small className="text-danger">
            {message}
          </small>
        )}
      />
    </>
    )
}

export default DatePickerInput